/** Injectable source of randomness so tests can make outcomes deterministic. */
export type RandomSource = () => number;

/**
 * Inclusive integer in `[1, max]`.
 *
 * @throws if `max` is not a positive integer.
 */
export function randomInt1To(max: number, random: RandomSource = Math.random): number {
  if (!Number.isInteger(max) || max < 1) {
    throw new Error(`randomInt1To expects a positive integer, received: ${max}`);
  }
  return Math.floor(random() * max) + 1;
}

/** Uniformly picks one entry. @throws on an empty list. */
export function pickOne<T>(items: readonly T[], random: RandomSource = Math.random): T {
  if (items.length === 0) {
    throw new Error('pickOne requires a non-empty array');
  }
  return items[randomInt1To(items.length, random) - 1]!;
}
